import styled from "styled-components";
import { theme } from "../../../config";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  @media (max-width: 1400px) {
    padding: 25px 60px 15px;
  }
  @media (max-width: 1300px) {
    padding: 25px 40px 15px;
  }
  @media (max-width: 1200px) {
    padding: 25px 30px 15px;
  }
  overflow: auto;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
  gap: 1.3em;

  @media (min-width: 1200px) {
    gap: 1.2em;
  }

  @media (min-width: 1600px) {
    gap: 1.3em;
  }
`;

export const FunnelWrapper = styled.div`
  height: 556px;
`;

export const JobOfferWrapper = styled.div`
  height: 205px;
  margin-top: 1px;
`;

export const FailedReasonWrapper = styled.div`
  height: 200px;
`;

export const RightSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  margin-top: 3em;
`;

export const ApplicantInsightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;

  @media (min-width: 1025px) and (max-width: 1120px) {
    flex-direction: column;
  }

  & > div {
    height: 120px;
    padding: 16px 25px 25px 25px;
  }
`;

export const LostApplicantWrapper = styled.div<{ isLoss: boolean }>`
  width: 100%;
  height: ${({ isLoss }) => (isLoss ? "200px" : "205px")};

  @media (max-width: 1599px) {
    margin-top: 2px;
  }
`;

export const StyledRangePicker = styled(RangePicker)`
  ${theme.defaultInputStyle}
  width: ${(props: any) => props.width || "100%"};
  margin-bottom: 2px;
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 30px;
  }

  .ant-picker-input {
    width: 80%;
  }

  .ant-picker-input ~ .ant-picker-input {
    width: 100%;
  }

  @media (min-width: 768px) {
    .ant-picker-input {
      width: 95%;
    }
  }

  @media (min-width: 800px) {
    .ant-picker-input {
      width: 84%;
    }
  }

  @media (min-width: 992px) {
    .ant-picker-input {
      width: 50%;
    }
  }

  @media (min-width: 1025px) {
    .ant-picker-input {
      width: 85%;
    }
  }

  @media (min-width: 1120px) {
    .ant-picker-input {
      width: 60%;
    }
  }

  @media (min-width: 1200px) {
    .ant-picker-input {
      width: 85%;
    }
  }

  @media (min-width: 1300px) {
    .ant-picker-input {
      width: 70%;
    }
  }

  @media (min-width: 1400px) {
    .ant-picker-input ~ .ant-picker-input {
      padding-left: 0.5em;
    }
    .ant-picker-input {
      width: 65%;
    }
  }

  @media (min-width: 1530px) {
    .ant-picker-input {
      width: 55%;
    }
  }

  @media (min-width: 1640px) {
    .ant-picker-input {
      width: 45%;
    }
  }

  @media (min-width: 1720px) {
    .ant-picker-input {
      width: 40%;
    }
  }

  @media (min-width: 1810px) {
    .ant-picker-input {
      width: 35%;
    }
  }

  @media (min-width: 1890px) {
    .ant-picker-input {
      width: 31%;
    }
  }

  .ant-picker-input > input {
    color: #111111;
    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 12.6px;
      line-height: 16px;
    }
  }
  &.ant-picker.ant-picker-disabled {
    border: 1px solid ${theme.colors.borderColor};
    background-color: ${theme.colors.neutral.black7};
  }
  &.ant-picker.ant-picker-disabled:hover {
    border: 1px solid ${theme.colors.secondary};
  }
  .ant-picker-input > input[disabled] {
    color: ${theme.colors.neutral.black3};
  }
  .ant-picker-suffix {
    color: rgb(38, 38, 38);
  }
`;

export const OtherReasonsModalBodyWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  height: 224px;
  overflow-y: auto;
`;

export const OtherReasonsModalBodyItem = styled.li`
  color: ${theme.colors.neutral.black2};
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
`;

export const OtherReasonsModalFooterWrapper = styled.div`
  display: flex;
  justify-content: end;
  border-radius: 4px;
`;
